import styled from "styled-components";
import { padding, position } from "polished";
const CardBannerWrapper = styled("div")({
  ...padding(`${72 / 302 * 100}%`, 0, 16),
  position: "relative"
});
const CardBannerInner = styled("div")({
  alignItems: "flex-end",
  display: "flex",
  padding: "0 16px",
  ...position("absolute", 0)
});
const CardBannerFigure = styled("figure")(({ theme }) => ({
  borderBottom: `1px solid ${theme.color.monochrome4}`,
  boxSizing: "content-box",
  display: "block",
  margin: 0,
  padding: 0,
  ...position("absolute", 0, 0, 16),
  overflow: "hidden"
}));
const CardBannerImage = styled("img")({
  display: "block",
  height: "auto",
  width: "100%"
});
export {
  CardBannerFigure,
  CardBannerImage,
  CardBannerInner,
  CardBannerWrapper
};
